import {
  itemClicked,
  type itemClickedType,
} from '../../../../app/browser/analyticsHelpers';

const otherProps = {
  serviceProviderId: '[[serviceProviderId]]',
};

const sectionState = {
  isContactComplete: '[[serviceProviderProfile.getProfileCompletion.response.contact.complete]]',
  isAboutComplete: '[[serviceProviderProfile.getProfileCompletion.response.about.complete]]',
  isHoursComplete: '[[serviceProviderProfile.getProfileCompletion.response.hours.complete]]',
  isServiceDetailsComplete: '[[serviceProviderProfile.getProfileCompletion.response.serviceDetails.complete]]',
  isProjectShowcaseComplete: '[[serviceProviderProfile.getProfileCompletion.response.showcase.complete]]',
  isPhotoGalleryComplete: '[[serviceProviderProfile.getProfileCompletion.response.photos.complete]]',
  isLicensingComplete: '[[serviceProviderProfile.getProfileCompletion.response.licensing.complete]]',
};

export default {
  elements: {
    'Edit-Profile--ManageMenuNav-BMT-QBO': (itemClicked('Manage My Business', 'QuickBooks Online Sync', otherProps): itemClickedType),
    'Edit-Profile--MenuNav-Contact-Information': (itemClicked('SP Profile: Navigation', `Contact: Complete State ${sectionState.isContactComplete}`, otherProps): itemClickedType),
    'Edit-Profile--MenuNav-About': (itemClicked('SP Profile: Navigation', `About: Complete State ${sectionState.isAboutComplete} `, otherProps): itemClickedType),
    'Edit-Profile--MenuNav-Hours': (itemClicked('SP Profile: Navigation', `Hours: Complete State ${sectionState.isHoursComplete}`, otherProps): itemClickedType),
    'Edit-Profile--MenuNav-Service-Details': (itemClicked('SP Profile: Navigation', `Service Details: Complete State ${sectionState.isServiceDetailsComplete} `, otherProps): itemClickedType),
    'Edit-Profile--MenuNav-Project-Showcase': (itemClicked('SP Profile: Navigation', `Showcase: Complete State ${sectionState.isProjectShowcaseComplete} `, otherProps): itemClickedType),
    'Edit-Profile--MenuNav-Photo-Gallery': (itemClicked('SP Profile: Navigation', `Photo-Gallery: Complete State ${sectionState.isPhotoGalleryComplete}`, otherProps): itemClickedType),
    'Edit-Profile--MenuNav-Licensing': (itemClicked('SP Profile: Navigation', `Licensing: Complete State ${sectionState.isLicensingComplete}`, otherProps): itemClickedType),
  },
};



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/menuAnalytics.js